<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="{{party}}" class="bordered" [formGroup]="shipment.shipmentForm.get( party )" [class.invalid]="(shipment.highlightInvalid$ | async) && businessForm.invalid">
   <mat-expansion-panel-header>
      <mat-panel-title [id]="party + 'PanelTitle'">
         {{party | spacers | titlecase}}
      </mat-panel-title>
   </mat-expansion-panel-header>

   <section>
      <div>
         <mat-form-field class="full">
            <input [id]="party + 'LocationInput'" matInput #location placeholder="Location" formControlName="name" [required]="config?.items?.name?.required && !isQuote" [maxlength]="config?.items?.name?.maxLength" [matAutocomplete]="auto" />
            <mat-error [id]="party + 'LocationError'" libInputErrors [control]="businessForm.get('name')"></mat-error>
            <mat-hint align="end" *ngIf="config?.items?.name?.maxLength && businessForm.get('name')?.value?.length as l">{{l || 0}} / {{config?.items?.name?.maxLength}}</mat-hint>
            <mat-icon [id]="party + 'LocationAddIcon'" matSuffix class="add"
               *ngIf="businessForm.get('name').value && !businessForm.get('id').value && businessForm.valid"
               (click)="create()"
               [class.loop]="loop"
               matTooltip="Save as new Location">
               {{( loop ) ? 'loop' : 'library_add'}}
            </mat-icon>
            <mat-icon matSuffix class="good" *ngIf="businessForm.get('id').value && businessForm.valid">check</mat-icon>
         </mat-form-field>

         <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateBusiness( $event )" autoActiveFirstOption>
            <mat-option [id]="party + 'LocationOption'" *ngFor="let entry of autocompleteOptions | async" [value]="entry">
               {{ entry.name }}
            </mat-option>
         </mat-autocomplete>
      </div>

      <ng-container *ngIf="countries.countriesByDomesticFactor( shipment.shipType ) | async as _countries; else spinner">
         <div>
            <mat-form-field class="country">
               <mat-label>Country</mat-label>
               <mat-select [id]="party + 'CountrySelect'" formControlName="country" [required]="config?.items?.country?.required">
                  <mat-option [id]="_countries + 'Option'" *ngIf="_countries.length > 10">
                     <ngx-mat-select-search [id]="party.toLowerCase() + 'CountrySearch'" [formControl]="countriesFilter" placeholderLabel="Search" noEntriesFoundLabel="Option Not Found"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option [id]="( country.country | camelcase ) + 'Option'" *ngFor="let country of filteredCountries | async" [value]="country.code">{{country.country}}</mat-option>
               </mat-select>
               <mat-error [id]="party + 'CountryError'" libInputErrors [control]="businessForm.get('country')"></mat-error>
            </mat-form-field>

            <ng-container *ngIf="shipment.mode === 'ocean'">
               <ng-container *ngIf="countries.ports( country ) | async as c; else spinner">
                  <mat-form-field class="port" *ngIf="c.ports as ports">
                     <mat-label>
                        {{party === 'shipper' ? 'Origin' : 'Destination'}} Port
                     </mat-label>
                     <mat-select [formControl]="port">
                        <mat-option>No Port</mat-option>
                        <mat-option *ngFor="let port of ports" [value]="port">
                           {{port}}
                        </mat-option>
                     </mat-select>
                  </mat-form-field>
               </ng-container>
            </ng-container>
         </div>
         
         <div>
            <mat-form-field class="full" *ngIf="businessForm.get('address1') != null">
               <mat-label>Address Line 1</mat-label>
               <input [id]="party + 'AddressLine1Input'" matInput formControlName="address1" [required]="config?.items?.address1?.required && !isQuote" [maxlength]="config?.items?.address1?.maxLength" />
               <mat-error [id]="party + 'AddressLine1Error'" libInputErrors [control]="businessForm.get('address1')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.address1?.maxLength && businessForm.get('address1')?.value?.length as l">{{l || 0}} / {{config?.items?.address1?.maxLength}}</mat-hint>
            </mat-form-field>
         </div>

         <div>
            <mat-form-field class="full" *ngIf="businessForm.get('address2') != null">
               <mat-label>Address Line 2</mat-label>
               <input [id]="party + 'AddressLine2Input'" matInput formControlName="address2" [required]="config?.items?.address2?.required" [maxlength]="config?.items?.address2?.maxLength" />
               <mat-error [id]="party + 'AddressLine2Error'" libInputErrors [control]="businessForm.get('address2')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.address2?.maxLength && businessForm.get('address2')?.value?.length as l">{{l || 0}} / {{config?.items?.address2?.maxLength}}</mat-hint>
            </mat-form-field>
         </div>

         <div>
            <mat-form-field class="full" *ngIf="businessForm.get('address3') != null">
               <mat-label>Address Line 3</mat-label>
               <input [id]="party + 'AddressLine3Input'" matInput formControlName="address3" [required]="config?.items?.address3?.required" [maxlength]="config?.items?.address3?.maxLength" />
               <mat-error [id]="party + 'AddressLine3Error'" libInputErrors [control]="businessForm.get('address3')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.address3?.maxLength && businessForm.get('address3')?.value?.length as l">{{l || 0}} / {{config?.items?.address3?.maxLength}}</mat-hint>
            </mat-form-field>
         </div>

         <div class="citystate" *ngIf="businessForm.get('city') != null">
            <mat-form-field class="city">
               <mat-label>City</mat-label>
               <input [id]="party + 'CityInput'" matInput formControlName="city" [required]="config?.items?.city?.required || isQuote"
                  [maxlength]="config?.items?.city?.maxLength" />
               <mat-error [id]="party + 'CityError'" libInputErrors [control]="businessForm.get('city')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.city?.maxLength && businessForm.get('city')?.value?.length as l">{{l || 0}} / {{config?.items?.city?.maxLength}}</mat-hint>
            </mat-form-field>

            <!-- NO COUNTRY: This will display if no country is selected yet -->
            <ng-container *ngIf="isQuote && !country">
               <mat-form-field class="state">
                  <mat-label>Region</mat-label>
                  <mat-select [id]="party + 'StateSelect'" [required]="true" formControlName="state">
                     <mat-option [id]="party + 'StateOption'">
                        <ngx-mat-select-search [id]="party + 'StateSearch'" placeholderLabel="Search"
                           noEntriesFoundLabel="Option Not Found"></ngx-mat-select-search>
                     </mat-option>
                     <mat-option>
                        {{ "" }}
                     </mat-option>
                  </mat-select>
                  <mat-error [id]="party + 'StateError'" libInputErrors [control]="businessForm.get('state')"></mat-error>
               </mat-form-field>

               <mat-form-field class="zip" *ngIf="businessForm.get('postalcode') != null">
                  <mat-label>Postal Code</mat-label>
                  <input [id]="party + 'PostalCodeInput'" matInput [placeholder]="'Postal Code'" formControlName="postalcode"
                     [required]="config?.items?.postalcode?.required || postalValidator || stateRequired"
                     [maxlength]="config?.items?.postalcode?.maxLength" />
                  <mat-error [id]="party + 'PostalCodeError'" libInputErrors [control]="businessForm.get('postalcode')"></mat-error>
                  <mat-hint align="end"
                     *ngIf="config?.items?.postalcode?.maxLength && businessForm.get('postalcode')?.value?.length as l">{{l
                     || 0}} / {{config?.items?.postalcode?.maxLength}}</mat-hint>
               </mat-form-field>
            </ng-container>
            <!-- NO COUNTRY END -->

            <!-- HAS COUNTRY: This will display if country is selected -->
            <ng-container *ngIf="country">
               <ng-container *ngIf="countries.country( country ) | async as active; else spinner">
                  <ng-container *ngIf="active.regions && active.regions.length">
                     <mat-form-field class="state" *ngIf="businessForm.get('state') != null">
                        <mat-label>{{active.code === 'US' ? 'State' : 'Region'}}</mat-label>
                        <mat-select  [id]="party + 'StateSelect'" formControlName="state" [required]="config?.items?.state?.required || stateRequired">
                           <mat-option id="stateOption" *ngIf="active.regions.length > 10">
                              <ngx-mat-select-search [id]="party + 'StateSearch'" [formControl]="regionsFilter" placeholderLabel="Search" noEntriesFoundLabel="Option Not Found"></ngx-mat-select-search>
                           </mat-option>
                           <mat-option id="stateOption" *ngFor="let state of filteredRegions | async" [value]="state.code">
                              {{state.region}}
                           </mat-option>
                        </mat-select>
                        <mat-error [id]="party + 'StateError'" libInputErrors [control]="businessForm.get('state')"></mat-error>
                     </mat-form-field>
                  </ng-container>

                  <mat-form-field class="zip" *ngIf="businessForm.get('postalcode') != null">
                     <mat-label>Postal Code</mat-label>
                     <input [id]="party + 'PostalCodeInput'" matInput [placeholder]="active.postalDetails?.postalExample" formControlName="postalcode"
                        [required]="config?.items?.postalcode?.required || postalValidator || isQuote"
                        [maxlength]="config?.items?.postalcode?.maxLength" />
                     <mat-error [id]="party + 'PostalCodeError'" libInputErrors [control]="businessForm.get('postalcode')"></mat-error>
                     <mat-hint align="end" *ngIf="config?.items?.postalcode?.maxLength && businessForm.get('postalcode')?.value?.length as l">{{l || 0}} / {{config?.items?.postalcode?.maxLength}}</mat-hint>
                  </mat-form-field>
               </ng-container>
            </ng-container>
            <!-- HAS COUNTRY END -->
         </div>

         <div class="contact" formGroupName="contact" *ngIf="businessForm.get('contact') != null">
            <mat-form-field class="contact-name" *ngIf="contact.get('name') != null">
               <mat-label>Contact Name</mat-label>
               <input [id]="party + 'ContactNameInput'" matInput formControlName="name" [matAutocomplete]="autocontact" [required]="config?.items?.contact?.items?.name?.required" [maxlength]="config?.items?.contact?.items?.name?.maxLength" />
               <mat-error [id]="party + 'ContactNameError'" libInputErrors [control]="contact.get('name')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.contact?.items?.name?.maxLength && contact.get('name')?.value?.length as l">{{l || 0}} / {{config?.items?.contact?.items?.name?.maxLength}}</mat-hint>
            </mat-form-field>

            <mat-form-field class="contact-phone" *ngIf="contact.get('phone') != null">
               <mat-label>Phone</mat-label>
               <input [id]="party + 'ContactPhoneInput'"matInput formControlName="phone" [required]="config?.items?.contact?.items?.phone?.required" [maxlength]="config?.items?.contact?.items?.phone?.maxLength" />
               <mat-error [id]="party + 'ContactPhoneError'" libInputErrors [control]="contact.get('phone')"></mat-error>
               <mat-hint align="end" *ngIf="config?.items?.contact?.items?.phone?.maxLength && contact.get('phone')?.value?.length as l">{{l || 0}} / {{config?.items?.contact?.items?.phone?.maxLength}}</mat-hint>
            </mat-form-field>

            <mat-autocomplete #autocontact="matAutocomplete" (optionSelected)="updateContact( $event )">
               <mat-option [id]="party + 'ContactOption'" *ngFor="let c of contacts | async" [value]="c">{{c.name}}</mat-option>
            </mat-autocomplete>
         </div>
      </ng-container>
   </section>
</mat-expansion-panel>
